import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { Button } from '@sg/garnish';

import { type ScanToPayPalette } from '../../utils';

export const ScanToPayFaqCta = (props: ScanToPayFaqCtaProps) => {
  const { palette, onPress } = props;

  const { formatMessage } = useIntl();
  const a11yLabel = formatMessage(messages.a11yLabel);

  return (
    <View style={styles.container}>
      <Button
        palette={palette === 'cream' ? 'kale' : 'cream'}
        size="large"
        accessibilityRole="button"
        accessibilityLabel={a11yLabel}
        onPress={onPress}
      >
        <FormattedMessage {...messages.cta} />
      </Button>
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  cta: {
    defaultMessage: 'FAQ',
    description: 'Scan To Pay | FAQ CTA',
  },
  a11yLabel: {
    defaultMessage: 'Open FAQ',
    description: 'Scan To Pay | FAQ CTA | Accessibility Label',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ScanToPayFaqCtaProps = {
  palette: ScanToPayPalette;
  onPress: () => void;
};
